"use client";
import GraduallyMotion from "@/components/motion/Gradually";
import { useTranslation } from "@/lib/i18n";
import { useResumeStore } from "@/lib/store/resume";
import classNames from "classnames";

export const colors: string[] = [
  "#16a34a", // green-600
  "#059669", // emerald-600
  "#0d9488", // teal-600
  "#0891b2", // cyan-600
  "#0284c7", // sky-600
  "#2563eb", // blue-600
  "#4f46e5", // indigo-600
  "#475569", // slate-600
  "#57534e", // stone-600
  "#dc2626", // red-600
  "#ea580c", // orange-600
  "#d97706", // amber-600
  "#ca8a04", // yellow-600
  "#65a30d", // lime-600
  "#7c3aed", // violet-600
  "#9333ea", // purple-600
  "#c026d3", // fuchsia-600
  "#db2777", // pink-600
  "#e11d48", // rose-600
];

export const Theme = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const theme = useResumeStore((state) => state.resume.data.settings?.theme);
  const { t } = useTranslation({ ns: "resume-sidebar" });

  return (
    <main className="flex flex-col flex-wrap gap-4">
      <GraduallyMotion className="max-w-[400px] ">
        <div className="text-md mb-1 font-bold leading-8">
          {t("right.theme.colors")}
        </div>
        <div className="flex flex-wrap gap-4">
          {colors.map((color) => (
            <div
              key={color}
              onClick={() => {
                setValue("settings.theme.primary", color);
              }}
              className={classNames(
                "flex h-[33px] w-[33px] cursor-pointer items-center justify-center rounded ring-primary ring-offset-1 ring-offset-background transition-shadow hover:ring-1",
                theme?.primary === color && "ring-2",
              )}
            >
              <div
                className="h-[32px] w-[32px] rounded"
                style={{ backgroundColor: color }}
              />
            </div>
          ))}
        </div>
      </GraduallyMotion>
    </main>
  );
};
